import dom from '../../libs/dom';
import GameLoop from '../../libs/GameLoop';
import MainCanvas from './Canvas';
import update from './update';
import addSceneEvents from './SceneEvents';
import addEntities from './entities';

class SwitchScene {
  constructor(app) {
    this.app = app;

    const canvasWidth = 150;
    const canvasHeight = 60;

    this.mainCanvas = new MainCanvas({ width: canvasWidth, height: canvasHeight });

    this.initializeDom();

    this.positionScene();

    addSceneEvents(this);

    // start game loop last
    this.gameLoop = new GameLoop((delta) => {
      update(this, delta);
    });
  }

  initializeDom() {
    this.elContainer = document.querySelector('.site-header');

    this.canvasContainer = dom.make('<div class="canvas-container"></div>');
    this.canvasContainer.appendChild(this.mainCanvas.canvas);

    this.sceneContainer = dom.make('<div class="scene-container"></div>');
    this.sceneContainer.appendChild(this.canvasContainer);

    this.elContainer.appendChild(this.sceneContainer);

    this.sceneContainer.style.bottom = '-3px';
    this.sceneContainer.style.zIndex = '100';

    setTimeout(() => {
      document.body.classList.add('show-scene');
    }, 300);
  }

  positionScene() {
    this.prevBottomEnter = this.bottomEnter;

    this.bottomEnter = (window.matchMedia('(max-width: 900px)').matches);

    if (this.prevBottomEnter !== this.bottomEnter) this.freshStart();

    if (window.matchMedia('(max-width: 700px)').matches) {
      this.sceneContainer.style.left = '30%';

      document.body.classList.add('ladder-from-bottom');
    } else if (window.matchMedia('(max-width: 900px)').matches) {
      this.sceneContainer.style.left = 0;

      document.body.classList.add('ladder-from-bottom');
    } else {
      const lightTextLeft = document.querySelector('.light-text').getBoundingClientRect().left;

      this.sceneContainer.style.left = `${lightTextLeft - this.mainCanvas.width - 15}px`;
    }
  }

  freshStart() {
    this.entities = null;

    addEntities(this);

    this.camera = {
      focus: { x: 0, y: 0 },
    };

    document.body.className = '';

    this.inputDisabled = true;

    setTimeout(() => {
      this.switchOff();
    }, 1500);
  }

  switchOff() {
    if (this.app.pipeScene) this.app.pipeScene.pipeEnd.active = false;
    this.inputDisabled = true;

    document.body.classList.remove('flicker-text-off');
    document.body.classList.remove('flicker-text');

    setTimeout(() => {
      document.body.classList.add('flicker-text-off');
    }, 0);

    this.switchBox.frame = 1;

    setTimeout(() => {
      this.player.flipped = false;
      this.player.climbingUp = false;
      this.player.steppingBack = false;
      this.player.walkingToSwitch = false;
      this.player.climbingDownExit = false;
      this.player.climbingUpEnter = false;
      this.player.climbingDown = false;

      if (this.bottomEnter) {
        this.player.climbingUpEnter = true;
      } else {
        this.player.climbingDown = true;
      }
    }, 1000);
  }
}

export default SwitchScene;
